import { render, staticRenderFns } from "./item-list-all.vue?vue&type=template&id=cb7add64&"
import script from "./item-list-all.vue?vue&type=script&lang=js&"
export * from "./item-list-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports